module.exports = "<div class=\"form-control component-input-control\"> {{#if unvisible}} <p class=info>权限受限</p> {{else if be_control_condition}} <p class=info>被修改条件限制</p> {{else}} <input type=text class=\"search dynamic-form-input ui-width recipients\" value={{value}}> <div style=float:left class=form-print-icon> {{#if required}} <span id=requiredLogo class={{requiredClass}}></span> {{/if}} <a href=javascript:void(0); class=\"ui-selector icon-add-user form-icon{{fontsize}} visible\" title=选择器></a> </div> {{/if}} </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/form/post-message/post-message-get-user.html
// module id = 4728
// module chunks = 50